export { default } from './CarTags';
